import { connect } from 'react-redux';

import { push } from '@talend/router-bridge';

import { SidePanel } from './SidePanel.component';

const mapDispatchToProps = (dispatch: Function) => ({
	navigate: (event: Event, url: string) => {
		event.preventDefault();
		dispatch(push(url));
	},
});

export const ConnectedSidePanel = connect(null, mapDispatchToProps)(SidePanel);
